import type { TFunction } from 'i18next'
import { z } from 'zod'

import { CSV_TYPE, XLSX_TYPE } from '@/constants/file'

const MAX_FILE_SIZE = 5242880

export const getTradeImportSchema = (t: TFunction) =>
  z.object({
    fileContent: z
      .any()
      .refine(Boolean, t('wholesale.trade.import.form.file_required_excel_or_csv_error'))
      .refine((file) => file?.size <= MAX_FILE_SIZE, t('wholesale.trade.import.form.file_too_big_error'))
      .refine(
        (file) => file?.type === XLSX_TYPE || file?.type === CSV_TYPE,
        t('wholesale.trade.import.form.file_required_excel_or_csv_error'),
      ),
  })
